import store from '../store/index.js';
import logger from '../logger/index.js';
import decimalHelper from './common/decimalHelper.js';

export default {
  install(Vue) {
    // 쿠키 조회
    Vue.config.globalProperties.$getCookie = function (cname) {
      let name = cname + '=';
      let decodedCookie = unescape(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    };

    // 고대비 모드 변경
    Vue.config.globalProperties.$changeDarkMode = function (isDarkMode) {
      let wrapper = document.querySelectorAll('.wrap');
      if (wrapper && wrapper.length > 0) {
        if (isDarkMode) {
          for (let i = 0; i < wrapper.length; i++) {
            if (!wrapper[i].classList.contains('dark')) {
              wrapper[i].classList.add('dark');
            }
          }
        } else {
          for (let i = 0; i < wrapper.length; i++) {
            wrapper[i].classList.remove('dark');
          }
        }
      }
    };

    // 대기화면 고대비 모드 변경
    Vue.config.globalProperties.$changeDarkModeIdle = function (isDarkMode) {
      let idleWrapper = document.querySelector('#idle');
      if (idleWrapper) {
        if (isDarkMode) {
          if (!idleWrapper.classList.contains('dark')) {
            idleWrapper.classList.add('dark');
          }
        } else {
          idleWrapper.classList.remove('dark');
        }
      }
    };

    // 로딩 이미지 토글
    Vue.config.globalProperties.$toggleLoadingIcon = function (isShow) {
      let body = document.querySelector('body');
      if (body) {
        let divTag = body.querySelector('.loading');
        if (divTag) divTag.remove();

        if (isShow) {
          let images = require.context('../assets/images/common/', false, /\.gif$/);
          let divTag = document.createElement('div');
          divTag.classList = 'loading';

          let imgTag = document.createElement('img');
          imgTag.src = images('./artwork_loading.gif');

          let msgTag = document.createElement('div');
          msgTag.id = 'loadingMsg';
          msgTag.classList = 'loadingMsg';

          let retbtn = document.createElement('button');
          retbtn.id = 'retryBtn';
          retbtn.innerText = 'RETRY';
          retbtn.classList = 'disp_off';
          retbtn.addEventListener('click', () => {
            this.kioskReadyRetry();
          });

          divTag.append(imgTag);
          divTag.append(msgTag);
          divTag.append(retbtn);

          body.append(divTag);
        }
      }
    };

    // progress 토글
    Vue.config.globalProperties.$toggleProgressIcon = function (isShow) {
      let body = document.querySelector('body');
      if (body) {
        let divTag = body.querySelector('.progress-icon-wrap');
        if (divTag) divTag.remove();

        if (isShow) {
          let divWrapTag = document.createElement('div');
          divWrapTag.classList = 'progress-icon-wrap';

          let divTag = document.createElement('div');
          divTag.classList = 'progress-icon';

          divWrapTag.append(divTag);

          body.append(divWrapTag);
        }
      }
    };

    // 버튼 애니메이션
    Vue.config.globalProperties.$showButtonAnimation = function () {
      let animButtons = document.querySelectorAll('.btn-anim');
      if (animButtons && animButtons.length > 0) {
        for (let i = 0; i < animButtons.length; i++) {
          if (animButtons[i].getAttribute('disabled') == null) {
            animButtons[i].addEventListener('mousedown', bindMouseDown);
            animButtons[i].addEventListener('mouseup', bindMouseUp);
            animButtons[i].addEventListener('mouseleave', bindMouseUp);
            animButtons[i].addEventListener('touchstart', bindMouseDown);
            animButtons[i].addEventListener('touchend', bindMouseUp);
            animButtons[i].addEventListener('touchcancel', bindMouseUp);
          }
        }
      }
    };

    // 상품 가격 계산
    Vue.config.globalProperties.$detailUprc = (item) => {
      const posConfig = store.getters.getPosConfig.posConfig;
      // 1:매장(부가세율) 2:포장(경감세율) 3:추후선택(기본 부가세율) 4:sco
      const orderType = store.getters.getOrderType;

      const taxRate = posConfig.taxRate; //부가세율
      const reducedTaxRate = posConfig.reducedTaxRate; //경감세율
      const isTaxIncluded = posConfig.isTaxIncluded; //세금 판매가 포함 여부
      const decimalPlace = Number(posConfig.decimalPlace); //소수점 자리수
      const amountRoundType = posConfig.amountRoundType.toLowerCase(); //금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
      let saleUnit = Number(posConfig.saleUnit); //판매단위

      const discountAmountRoundType = posConfig.discountRoundType.toLowerCase(); //할인 금액 계산 방식 (반올림-round/절상-ceil/절하-floor)
      let discountSaleUnit = Number(posConfig.discountSaleUnit); //할인 판매단위

      let uprc = item.SALE_UPRC; //uprc : 최종 세후 가격
      if (typeof uprc == 'undefined') uprc = item.SALES_UPRC;

      // 판매단위 1 : 1단위, 2 : 10단위, 3 : 100단위, 4 : 100단위
      if (typeof saleUnit == 'undefined') {
        saleUnit = 10;
      }

      // 할인 판매단위 1 : 1단위, 2 : 10단위, 3 : 100단위, 4 : 100단위
      if (typeof discountSaleUnit == 'undefined') {
        discountSaleUnit = 10;
      }

      let orgUprc = uprc; // SALE_UPRC 원래 가격
      let evntDcAmt = 0;

      // 할인 금액 적용
      // SALE_UPRC에서 할인을 먼저 적용하고 세금을 계산함
      if (item.DC_ABLE_YN === 'Y' && item.EVNT_ITEM_CD != '' && item.EVNT_ITEM_CD != null) {
        const date = new Date();
        let now = date.getHours() + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());

        //타임세일이 적용되어 있지 않은 경우 or 타임세일 적용 시 시간 안에서만 할인 적용
        if (item.TIME_SALE_YN != 'Y' || (item.TIME_SALE_YN === 'Y' && item.TIME_SALE_FROM_TIME <= now && now <= item.TIME_SALE_END_TIME)) {
          //상품할인 금액 행사
          if (item.EVNT_FLG_CD === '03') {
            let evnt_dc_amt = item.EVNT_DC_AMT;

            //금액 할인
            if (item.EVNT_DC_FLG_CD == 1) {
              //% 할인
            } else if (item.EVNT_DC_FLG_CD == 2) {
              evnt_dc_amt = uprc * (item.EVNT_DC_AMT / 100); //할인율 적용 금액 산정
            }
            //할인 금액을 판매단위에 맞게 보정
            if (discountAmountRoundType == 'round') {
              evnt_dc_amt = decimalHelper.roundInt(evnt_dc_amt, discountSaleUnit - 1);
            } else if (discountAmountRoundType == 'floor') {
              evnt_dc_amt = decimalHelper.floorInt(evnt_dc_amt, discountSaleUnit - 1);
            } else {
              evnt_dc_amt = decimalHelper.ceilInt(evnt_dc_amt, discountSaleUnit - 1);
            }

            uprc = Number(uprc - evnt_dc_amt); //uprc에 할인 금액 뺀 가격 적용
            evntDcAmt = Number(evnt_dc_amt); //할인 금액
          }
        }
      }

      let taxRateUprc = uprc; //부가세 포함된 세후가격
      let reducedTaxRateUprc = uprc; //경감세율 포함된 세후가격

      /* 부가세 계산 시작 */
      //TAX_FLG_CD : 0 : 면세, 1 : 과세, 2 : 영세
      //세후 가격을 반환해야 하므로, SALE_UPRC가 세전 가격인 경우 세금 계산 로직 수행
      //과세 상품이고 판매단가가 세전 금액일 경우에만 세금 계산
      if (item.TAX_FLG_CD == 1 && !isTaxIncluded) {
        let reducedTax = reducedTaxRateUprc * (reducedTaxRate / 100); //경감세율 적용된 세금
        let tax = taxRateUprc * (taxRate / 100); //세금

        //판매 단위를 기준으로 먼저 분류
        // 1단위
        if (saleUnit === 1) {
          // 소수점 자리수 확인 하여 계산
          // 0 : 소수점 1단위에서 처리, 1 : 소수점 2단위에서 처리, 3 : 소수점 3 단위에서 처리
          if (amountRoundType === 'round') {
            reducedTax = decimalHelper.round(reducedTax, decimalPlace);
            tax = decimalHelper.round(tax, decimalPlace);
          } else if (amountRoundType === 'floor') {
            reducedTax = decimalHelper.floor(reducedTax, decimalPlace);
            tax = decimalHelper.floor(tax, decimalPlace);
          } else {
            reducedTax = decimalHelper.ceil(reducedTax, decimalPlace);
            tax = decimalHelper.ceil(tax, decimalPlace);
          }
          // 10단위, 100단위, 1000단위 - 소수점 자리수 필드는 의미 없고, 단위별 금액 계산 방식 적용
        } else {
          if (saleUnit > 1) {
            //소수점 하위는 버리고 시작
            reducedTax = Math.floor(reducedTax);
            tax = Math.floor(tax);

            if (amountRoundType == 'round') {
              reducedTax = decimalHelper.roundInt(reducedTax, saleUnit - 1);
              tax = decimalHelper.roundInt(tax, saleUnit - 1);
            } else if (amountRoundType == 'floor') {
              reducedTax = decimalHelper.floorInt(reducedTax, saleUnit - 1);
              tax = decimalHelper.floorInt(tax, saleUnit - 1);
            } else {
              reducedTax = decimalHelper.ceilInt(reducedTax, saleUnit - 1);
              tax = decimalHelper.ceilInt(tax, saleUnit - 1);
            }
          }
        }

        // 경감세율 적용 여부에 따라 세금 다르게 uprc에 더함
        // 경감 세율 적용 case : 포장하기 + 경감세율적용여부가능 상품(01) or SCO + 먹고가기 + 경감세율적용여부가능 상품(01)
        if ((orderType == 2 && item.TAX_RDC_CD === '01') || (orderType == 4 && item.EAT_IN === true && item.TAX_RDC_CD === '01')) {
          uprc = Number(uprc) + Number(reducedTax);
        } else {
          uprc = Number(uprc) + Number(tax);
        }
      }
      /* 부가세 계산 종료 */

      return uprc;
    };

    //가격 단위 및 표현 방식 변경
    Vue.config.globalProperties.$displayUprc = (uprc) => {
      const posConfig = store.getters.getPosConfig.posConfig;
      const currUnitText = store.getters.getCurrUnitText; //화폐 단위
      const amountUnit = posConfig.amountUnit; // 금액표현 단위 1 : 1234 4 : 1K
      const saleUnit = Number(posConfig.saleUnit); // 판매단위

      /* 판매단위 변경 */
      if (saleUnit > 1) uprc = Math.floor(uprc / Math.pow(10, saleUnit - 1)) * Math.pow(10, saleUnit - 1);

      // 금액 표현 단위
      if (store.getters.getLocale == 'ko') {
        if (amountUnit == '4') uprc = Math.floor(uprc / 1000).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'K' + currUnitText;
        else uprc = uprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + currUnitText;
      } else {
        if (amountUnit == '4') uprc = '₩' + Math.floor(uprc / 1000).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'K';
        else uprc = '₩' + uprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      return uprc;
    };

    let done = false;
    Vue.config.globalProperties.oneCallFn = () => {
      if (done) return done;
      else {
        done = true;
        return false;
      }
    };

    Vue.config.globalProperties.resetDone = () => {
      done = false;
    };

    Vue.config.globalProperties.$logInfo = (txt) => {
      var currentUrl = window.location.pathname;
      let pathName;
      if (currentUrl.split('/').length > 3) pathName = currentUrl.split('/')[2].toUpperCase() + '-' + currentUrl.split('/')[3].toUpperCase();
      else if (currentUrl == '/') pathName = 'App.vue';
      else pathName = currentUrl.split('/')[2].toUpperCase();

      var today = new Date();
      var year = today.getFullYear();
      var month = ('0' + (today.getMonth() + 1)).slice(-2);
      var day = ('0' + today.getDate()).slice(-2);
      var hours = ('0' + today.getHours()).slice(-2);
      var minutes = ('0' + today.getMinutes()).slice(-2);
      var seconds = ('0' + today.getSeconds()).slice(-2);
      var millisec = ('0' + today.getMilliseconds()).slice(-3);
      var dateString = year + '-' + month + '-' + day;
      var timeString = hours + ':' + minutes + ':' + seconds + ':' + millisec;

      logger.info(pathName, 'Timestamp : ' + dateString + ' ' + timeString + ' | Message : ' + txt);
    };

    Vue.config.globalProperties.$strToDate = (fromDate, endDate, type) => {
      let openDate = new Date();
      openDate.setHours(fromDate.substr(0, 2));
      openDate.setMinutes(fromDate.substr(2, 2));

      let closeDate = new Date();
      if (endDate <= fromDate) closeDate.setHours(parseInt(endDate.substr(0, 2)) + 24);
      else closeDate.setHours(endDate.substr(0, 2));

      closeDate.setMinutes(endDate.substr(2, 2));

      if (type == 0) {
        return openDate;
      } else {
        return closeDate;
      }
    };
  },
};

function bindMouseDown(event) {
  // console.log('bindMouseDown()');
  event.currentTarget.classList.remove('mouseup');
  event.currentTarget.classList.add('mousedown');
}
function bindMouseUp(event) {
  // console.log('bindMouseUp()');
  event.currentTarget.classList.remove('mousedown');
  event.currentTarget.classList.add('mouseup');
}
